import { navigationActions } from "../reducer";

import { ClientEventHistoryPathFilter } from "../../types";

export const addClientEventHistoryFilter = (
  eventFilter: ClientEventHistoryPathFilter
) => navigationActions.addClientEventHistoryFilter(eventFilter);
